















import { chipClasses } from '@/utils/chipClasses.constant'
import Vue from 'vue'
export default Vue.extend({
  props: {
    status: String,
  },
  data() {
    return {
      chipClasses,
    }
  },
})
